import React, { useRef } from "react";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import { Input } from "antd";

const libraries = ["places"];

const PlaceAutocomplete = ({ value, onPlaceSelect }) => {
  const autocompleteRef = useRef(null);

  const onLoad = (autocomplete) => {
    autocompleteRef.current = autocomplete;
  };

  const onPlaceChanged = () => {
    const autocomplete = autocompleteRef.current;
    const place = autocomplete.getPlace();

    if (!place || !place.place_id) return;

    const service = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );

    service.getDetails(
      {
        placeId: place.place_id,
        fields: ["name", "website"],
      },
      (details, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          details
        ) {
          if (onPlaceSelect) {
            onPlaceSelect({
              name: details.name,
              website: details.website,
              rawPlace: details,
            });
          }
        } else {
          console.error("Error fetching place details:", status);
        }
      }
    );
  };

  const handleInputChange = (e) => {
    const manualInput = {
      ...value,
      name: e.target.value,
      website: "",
      industries: [],
      manual: true,
    };
    onPlaceSelect?.(manualInput);
  };

  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
      libraries={libraries}
    >
      <Autocomplete
        onLoad={onLoad}
        onPlaceChanged={onPlaceChanged}
        options={{ types: ["establishment"] }}
      >
        <Input
          value={value}
          className="common-input"
          placeholder="Search companies..."
          onChange={handleInputChange}
        />
      </Autocomplete>
    </LoadScript>
  );
};

export default PlaceAutocomplete;
